module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-11.3b850b7d.png";